export default __webpack_public_path__ + "static/pool-removal-banner-0c62e8c5b464eb6db4737ca076071d70.jpg";